import React from "react";
import { Info } from "lucide-react";

/**
 * MandatoryNotesCard
 *
 * Shown in excel mode on both FormSetup and EditForm to remind admins about
 * the three mandatory fields and the read-only constraint.
 */
export default function MandatoryNotesCard() {
  return (
    <div className="mandatory-notes-card">
      <div className="bulk-notes-header">
        <Info size={16} />
        <span>Note</span>
      </div>
      <ul className="udf-list">
        <li>
          {/* <strong>Email</strong>, <strong>Phone Number</strong>, and{" "} */}
          <strong>Amount</strong> is a mandatory field in every form.
        </li>
        <li>
          If this field is already present in your Excel file, they will be
          used directly.{" "}
          <strong>If not, it will be automatically added.</strong>
        </li>
        <li>
          If you tick the <strong>Read Only</strong> checkbox, ensure the
          required values already exist in your Excel file, as they cannot be
          auto-generated.
        </li>
      </ul>
    </div>
  );
}
